import { useEffect, useState } from 'react';
import {
  getUserProfile,
  UserProfileAggregate,
} from '@leagueplatform/user-profile-api';

/**
 * Fetches the current user's profile once on mount.
 * Minimal — no caching layer here because eos-apps doesn't take a direct
 * dependency on @tanstack/react-query. Callers that need cross-render caching
 * should hoist this into a context.
 */
export const useGetUserProfile = () => {
  const [data, setData] = useState<UserProfileAggregate | undefined>();
  const [error, setError] = useState<unknown>();

  useEffect(() => {
    let cancelled = false;
    getUserProfile()
      .then((profile) => {
        if (!cancelled) setData(profile);
      })
      .catch((err) => {
        if (!cancelled) setError(err);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { data, error };
};
